var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ theme : 'customTheme', placement : 'left', arrow : true }),expression:"{ theme : 'customTheme', placement : 'left', arrow : true }"}],attrs:{"content":_vm.logsCount}},[_vm._v("\n"+_vm._s(_vm.data.otherReasonLogsCount)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dffeb518","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/LogReasonTooltip.vue
// module id = 2244
// module chunks = 33